/* unplugin-vue-components disabled */import script from "./FabricCanvas.vue?vue&type=script&setup=true&lang=js"
export * from "./FabricCanvas.vue?vue&type=script&setup=true&lang=js"

import "./FabricCanvas.vue?vue&type=style&index=0&id=93ab84ca&lang=scss"

const __exports__ = script;

export default __exports__